module.exports = function getResource(label, vars = []) {
    const resources = {
        // PayPal SDK error handling (PAY-6427)
        paymentErrorTitle: 'Error',
        // Shown when user cancels PayPal flow
        paymentCancellation: 'Unable to place your order. Trouble connecting to PayPal. Please use a different payment method or try again later.<br /><br />If applicable, we have reversed any pending charges to your account.',
        // Shown when PayPal SDK or Payment Service returns an error
        paymentErrorMessage: 'Trouble connecting to PayPal. Please use a different payment method or try again later.',
        // Shown when PayPal authorization fails after successful authentication (PAY-6417)
        authorizationErrorMessage: 'We\'re sorry we cannot authorize your PayPal payment. Please select a different payment method. If applicable we have reversed any pending charges to your account.',
        okButton: 'OK'
    };

    return resources[label];
};
